import { useLingui } from '@lingui/react/macro';
import { useMemo } from 'react';

import {
  createEmptyFormState,
  type FormToolFormState,
} from './formFieldDefaults';

export interface FormToolTemplate {
  id: string;
  label: string;
  description: string;
  defaults: Partial<FormToolFormState>;
}

export function useFormToolTemplates(): FormToolTemplate[] {
  const { t } = useLingui();

  return useMemo(
    () => [
      {
        id: 'blank',
        label: t`Blank form`,
        description: t`Start with a single empty field.`,
        defaults: createEmptyFormState({ submitLabel: t`Submit` }),
      },
      {
        id: 'contact',
        label: t`Contact form`,
        description: t`Collect name, email, phone, and a message.`,
        defaults: {
          name: 'collect_contact_details',
          description:
            'Use when the user wants to be contacted or needs to leave their contact information.',
          formTitle: t`Contact details`,
          submitLabel: t`Send`,
          fields: [
            {
              name: 'full_name',
              label: t`Full name`,
              type: 'text',
              required: true,
            },
            {
              name: 'email',
              label: t`Email`,
              type: 'email',
              required: true,
            },
            {
              name: 'phone',
              label: t`Phone`,
              type: 'phone',
              required: false,
            },
            {
              name: 'message',
              label: t`Message`,
              type: 'textarea',
              required: false,
            },
          ],
        },
      },
    ],
    [t],
  );
}
